import { useState, useEffect } from 'react';
import { serviceService } from '@services/api';

export const useServices = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        const data = await serviceService.getAll();
        setServices(data);
        setError(null);
      } catch (err) {
        setError(err.message);
        // Mock data for demo
        setServices(getMockServices());
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  return { services, loading, error };
};

const getMockServices = () => [
  {
    id: '1',
    title: 'Professional Installation',
    description: 'Expert installation of security systems by certified technicians. Includes full setup, testing, and customer training on system operation.',
    price: 149.99,
    image: '/images/5.jpg',
  },
  {
    id: '2',
    title: 'System Maintenance',
    description: 'Regular maintenance and health checks for your security systems. Ensure optimal performance and longevity of your equipment.',
    price: 99.99,
    image: '/images/6.jpg',
  },
  {
    id: '3',
    title: 'Security Consultation',
    description: 'Professional security assessment and recommendations. Our experts will evaluate your premises and suggest the best security solutions.',
    price: 199.99,
    image: '/images/7.jpg',
  },
  {
    id: '4',
    title: 'Emergency Repair',
    description: '24/7 emergency repair service for urgent security system issues. Fast response time guaranteed.',
    price: 249.99,
    image: '/images/8.jpg',
  },
  {
    id: '5',
    title: 'System Upgrade',
    description: 'Upgrade your existing security system with the latest technology and features.',
    price: 299.99,
    image: '/images/9.jpg',
  },
];

